export const LIMIT_ITEM_PER_PAGE_PRODUCT_LIST = 20;

export const RECENTLY_VIEWED_PRODUCTS_KEY = 'viewed-products';

export const ITEM_PER_PAGE_IN_LISTING_PAGE = 40;

export const SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE = 20;

export const SEARCH_ALGO = {
  COOKIE: 'search_algorithm_v2',
  EXPIRE_TIME: 4 * 60 * 60 * 1000, // 4 hours in milliseconds
  REPLACE_PATTERN: /['"]+/g,
};
